import React, { useEffect, useState } from 'react';
import {
  FaCrown,
  FaUsers,
  FaWallet,
  FaChartLine,
  FaCheckCircle,
  FaLock,
} from 'react-icons/fa';

import api from '../../api/Api';
import { useTheme } from '../../context/ThemeContext';


const Transafers = () => {

  const { isDarkMode } = useTheme();

  const [loading, setLoading] = useState(true);
const transferData = [
  {
    id: 1,
    user: "Amit Kumar",
    amount: "+ $500.00",
    status: "Success",
    time: "10:30 AM"
  },
  {
    id: 2,
    user: "Devesh",
    amount: "- $120.00",
    status: "Pending",
    time: "12:15 PM"
  },
  {
    id: 3,
    user: "Soni",
    amount: "+ $2500.00",
    status: "Failed",
    time: "Yesterday"
  }
];

  const [transfer,setTransfer] = useState([])

  useEffect(() => {
    fetchTransfer();
  }, []);

  const fetchTransfer = async () => {

    try {

      setLoading(true);

      const { data } = await api.get('user-rank');

      if (data?.status) {

        setTransfer(data?.data || []);

    
      }

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  return (

    <div className={isDarkMode ? 'dark' : 'light'}>

      <div className="user-rank-container">

        {/* HEADER */}
        <div className="user-rank-header">

          <div>

      
            <div className="user-rank-main-title">
         Transfer
            </div>

      

          </div>

        </div>

  

        {/* LOADING */}
        {loading ? (

          <div className="common-loading">
            Loading ranks...
          </div>

        ) : (

          <div className="common-table-wrapper">

            <table className="common-table">

            <thead>
  <tr    style={{
                background: isDarkMode ? '#1d1d1d' : '#faf8f3',
              }} >
    <th style={{ fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Name</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Amount</th>
    <th style={{  fontWeight: 700, padding: '12px 16px', fontSize: 13, letterSpacing: .4, whiteSpace: 'nowrap' }}>Status</th>

  </tr>
</thead>

              <tbody>

                {transferData.map((item, index) => (

                  <tr key={index}>

                    {/* RANK */}
                    <td>

                      <div className="common-table-flex">

                        <div>

                          <div className="common-table-title">
                            {item.user}
                          </div>

                     

                        </div>

                      </div>

                    </td>

                    {/* DIRECT */}
                    <td>

                      <div className="common-table-flex">
                        <span className="common-table-text">
                          ₹{item.amount}
                        </span>

                      </div>

                    </td>

                    {/* SELF STAKE */}
                    <td>

                      <span className="common-table-text">
                  {item.status}
                      </span>

                    </td>



               

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}

      </div>

    </div>
  );
};

export default Transafers;